/** Checkbox / Radio / Switch: leaf.500 fill with a navy.900 check (never white on green). */
export const checkControl = {
  borderColor: "border.strong",
  borderWidth: "1px",
  borderRadius: "sm",
  bg: "surface.card",
  _checked: {
    bg: "leaf.500",
    borderColor: "leaf.500",
    color: "navy.900",
    _hover: { bg: "leaf.400", borderColor: "leaf.400" },
  },
  _indeterminate: { bg: "leaf.500", borderColor: "leaf.500", color: "navy.900" },
  _focusVisible: { boxShadow: "outline" },
  _invalid: { borderColor: "red.500" },
  _disabled: { bg: "sand.100", borderColor: "sand.300" },
};

export const checkLabel = { fontWeight: 500, fontSize: "0.9375rem", color: "text.primary", _disabled: { opacity: 0.5 } };

export const Checkbox = {
  baseStyle: { control: checkControl, label: checkLabel, icon: { color: "navy.900" } },
  defaultProps: { colorScheme: "leaf" },
};
